import React from "react";
import UnifiedFormComponent from "./components/UnifiedFormComponent";

const LaporanSistem = () => {
  const handleSuccess = (result) => {
    console.log('Sistem data saved successfully:', result);
  };

  const handleError = (error) => {
    console.error('Error saving Sistem data:', error);
  };

  return (
    <UnifiedFormComponent 
      formType="sistem"
      onSuccess={handleSuccess}
      onError={handleError}
    />
  );
};

export default LaporanSistem;
